import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

// Content
import Faq from "../components/Faq";

function Faqs() {
    return (
        <>
        <Navigation/>
        <Faq />
        <Footer />

    </>
    )
}

export default Faqs;